import React from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import { SymbolLink } from "@bw/icons"
import { Link } from "gatsby"

const gridStyle = css`
  display: grid;
  grid-template-columns: 18px 1fr;
  grid-gap: 15px;
  text-decoration-line: underline;
  align-items: center;
  color: var(--brand-dark-green);
  text-decoration: none;
`

const Download = styled.a`
  ${gridStyle}
`

const StyledLink = styled(Link)`
  ${gridStyle}
`

const Title = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  text-decoration: underline;
`

const Description = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  color: var(--font-color);
  text-decoration: none;
  margin-top: 2px;
`

const IconWrapper = styled.div`
  align-self: start;
  padding-top: 1px;
`

const File = ({ label, description, href, to }) => {
  const children = (
    <>
      <IconWrapper>
        <SymbolLink />
      </IconWrapper>
      <div>
        <Title>{label}</Title>
        {description && <Description>{description}</Description>}
      </div>
    </>
  )

  if (to !== undefined) {
    return <StyledLink {...{ to, children }} />
  }

  return (
    <Download
      {...{ href, children }}
      download
      target="_blank"
      rel="noreferrer"
    />
  )
}

File.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
  href: PropTypes.string,
  to: PropTypes.string,
}

export { File }
